export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="relative w-full lg:w-1/2 h-[320px] lg:h-[480px] overflow-hidden bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20close%20up%20of%20a%20black%20leather%20handbag%20with%20gold%20chain%20next%20to%20designer%20sunglasses%20and%20a%20silk%20twilly%20scarf%20on%20white%20travertine%2C%20soft%20afternoon%20sunlight%2C%20luxury%20editorial%20photography%2C%20rich%20textures%2C%20no%20text&width=900&height=720&seq=cta-v3-left&orientation=landscape"
            alt="Hoobuy Spreadsheet - Links verificados"
            title="Hoobuy Spreadsheet - Produtos selecionados"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          <div className="absolute top-4 left-6">
            <span className="text-xs font-medium text-white/80 uppercase tracking-wider">
              Oferta Exclusiva
            </span>
          </div>
          <div className="absolute bottom-8 left-6">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              Links Verificados
              <br />
              Atualizados
              <br />
              Diariamente
            </h2>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex items-center justify-center bg-background-50 py-14 md:py-20 px-8">
          <div className="max-w-[440px] text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              Comece Agora
              <br />
              Economize Tempo
            </h2>
            <p className="mt-5 text-base text-foreground-600 leading-relaxed">
              Cansado de links quebrados? Nosso Hoobuy Spreadsheet reúne os melhores fornecedores em um único lugar. Atualizado todos os dias para compradores do Brasil.
            </p>
            <div className="mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-10 py-4 bg-foreground-950 text-background-50 font-bold text-base rounded-full whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-300"
              >
                buy it now
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}